import TopBar from './components/TopBar';
import Hero from './components/Hero';
import ServicesGrid from './components/ServicesGrid';
import PricingSection from './components/PricingSection';
import MidPageCTA from './components/MidPageCTA';
import TrustSection from './components/TrustSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import StickyMobileBar from './components/StickyMobileBar';

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <TopBar />
      <main>
        <Hero />
        <ServicesGrid />
        <MidPageCTA />
        <PricingSection />
        <TrustSection />
        <FAQSection />
        <ContactSection />
        <FinalCTA />
      </main>
      <Footer />
      <StickyMobileBar />
    </div>
  );
}
